<template>
  <div class="result-wrapper">
    <h2>{{ $t('payment') }}</h2>
    <p v-if="loading">{{ $t('paymentCheck') }}</p>
    <p v-else-if="success">{{ $t('paymentSuccessResult') }}</p>
    <p v-else>{{ $t('paymentCanceled') }}</p>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useQuery } from '@vue/apollo-composable'
import checkPaymentQueryFile from '../graphql/checkPayment.query.gql'
import store from '../main'
import { isPlatform } from '@ionic/vue';

const httpLink = store.getters.httpLink
const route = useRoute();

const loading = ref(true);
const success = ref(false);

const { result: checkPaymentResult } = useQuery(checkPaymentQueryFile, ({ input: { resourcePath: route.query["resourcePath"] } }), { fetchPolicy: 'no-cache' })

watch(checkPaymentResult, (newData) => {
  if (!newData) return;
  const id = newData?.checkPayment?.id
  const ok = (id && id != '')
  loading.value = false;
  success.value = ok;
  sendToOpener(ok, { id: id, resourcePath: route.query["resourcePath"] })
  if (window.opener)
    setTimeout(() => {
      window.close();
    }, 1500);
});

function sendToOpener(ok, data) {
  if (window.opener) {
    window.opener.postMessage(
      {
        type: "PAYMENT_DONE",
        success: ok,
        ...data
      },
      window.location.origin
    );
  } else {
    setTimeout(() => {
      if (ok === true)
        window.location.href = `${window.location.origin}/payment?value=success`
      else 
        window.location.href = `${window.location.origin}/payment?value=failed`
    }, 1500);

  }
}
</script>

<style>
.result-wrapper {
  max-width: 480px;
  margin: 20px auto;
  text-align: center;
}
</style>
